export const PASSWORD_REGEX = {
  UPPERCASE: /[A-Z]/,
  LOWERCASE: /[a-z]/,
  SPECIAL_CHAR: /[!@#$%^&*(),.?":{}|<>]/,
  NUMBER: /\d/
};

export const isPasswordValid = (password: string): boolean => {
  if (!password || password.length < 8) return false;
  
  return (
    PASSWORD_REGEX.UPPERCASE.test(password) &&
    PASSWORD_REGEX.LOWERCASE.test(password) &&
    PASSWORD_REGEX.SPECIAL_CHAR.test(password) &&
    PASSWORD_REGEX.NUMBER.test(password)
  );
};

export const isPasswordFormValid = (password: string, confirmPassword: string): boolean => isPasswordValid(password) && password === confirmPassword;
